var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackChatIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97926 18.6134L10.2972 18.8562M10.2972 18.8562L11.2088 19.5523C11.5389 19.8044 12.0035 19.7782 12.3033 19.4907L12.516 19.2866C13.2026 18.6278 14.2839 19.4346 13.848 20.2805L13.6952 20.5769C13.5082 20.9398 13.6083 21.3846 13.9328 21.6324L15.2248 22.619L16.185 23.3523C16.6882 23.7365 17.4195 23.4492 17.5266 22.8252L17.8383 21.0089L18.3855 17.8208L19.2076 13.031C19.3226 12.3609 18.6374 11.8376 18.0212 12.125L13.6169 14.1793L10.6854 15.5467L9.01523 16.3257C8.44148 16.5934 8.35689 17.3745 8.86006 17.7588L10.2972 18.8562Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.842441
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackChatIcon);
export default __webpack_public_path__ + "static/media/black-chat-icon.6b80e3e4be2b865e613c976c54406f48.svg";
export { ForwardRef as ReactComponent };